// http://amanvirk.me/singleton-classes-in-es6/
let instance = null

/**
 * OverlayManager is a singleton class used by Overlay to keep track of all
 * open overlays in order to support nested overlays.
 */

class OverlayManager {
  constructor() {
    if (!instance) {
      instance = this
    }

    this._type = 'OverlayManager'
    this.modals = []

    return instance
  }

  add(modal) {
    this.modals.push(modal)
    return this.getOpenModalCount()
  }

  remove() {
    this.modals.pop()
    return this.modals.length < 1
  }

  getOpenModalCount() {
    return this.modals.length
  }

  get type() {
    return this._type
  }

  set type(value) {
    this._type = value
  }
}

export { OverlayManager }
